import React from 'react';
import classes from '../index.module.scss';
import Head from 'next/head';
import MetaTags from 'src/components/metaTags/MetaTags';
const domainURL = process.env.NEXT_PUBLIC_REACT_APP_DOMAIN;

function JsTermsOfUse() {
  let title = 'Terms Of Use';
  let link = domainURL + '/jh-terms-of-use';

  return (
    <React.Fragment>
      <MetaTags title={title} link={link} />
      <div className={classes['main-container']}>
        <div className={classes['container']}>
          <div className={classes['content-container']}>
            <div className={classes['title-content']}>
              <h1 className={classes['h1']}>JobsHorn- Terms of use</h1>
              <br />
              <span className={classes['ccpa-last-updated-time']}>Last Updated: 11/30/2022</span>
            </div>
            <br />
            <div>
              <p className={classes['p']}>
                JobsHorn is taking seriously to show valid jobs to JobsHorn, we expected JobsHorn adhere to bellow usage
                terms.
              </p>
              <ul>
                <li>
                  <p className={classes['p']}>
                    Report job if you think its irrelevant or Multi-Level Marketing or same job is posted multiple times
                    and locations.
                  </p>
                </li>
                <li>
                  <p className={classes['p']}>Apply for jobs that are relevant to your profile.</p>
                </li>
                <li>
                  <p className={classes['p']}>Job postings welcoming for anyone to apply.</p>
                </li>
              </ul>
            </div>
            <div>
              <p className={classes['p']}>JobsHorn, need job seekers support to make all job postings more accurate.</p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default JsTermsOfUse;
